<template>
    <!-- 页面内容区 -->
    <div class="content-area">
      <div class="content-title">请选择需要变更的续费类型</div>
  
      <!-- 卡片列表 -->
      <div class="card-list">
        <div
          class="renew-card"
          v-for="card in renewCards"
          :key="card.title"
          :class="{ selected: activeType === card.id }"
        >
          <div
            class="renew-card-info"
            @click="changeType(card.id)"
            :class="{ selected: activeType === card.id }"
          >
            <div class="renew-card-title">{{ card.title }}</div>
            <div class="renew-card-desc">{{ card.name }}</div>
          </div>
        </div>
      </div>
  
      <!-- ✅ 新增：外层输入区，选中才显示 -->
      <div v-if="activeType" class="card-action" style="display: flex; flex-direction: column; padding-top: 50px;">
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <span style="width: 40px;">价格:</span>
            <!-- <el-input
            v-model="price"
            placeholder="请输入价格"
            size="small"
            style="width: 160px;"
            ></el-input> -->
            <span style="width:160px">{{this.price}}</span>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <span style="width: 40px;">数量:</span>
            <el-input-number
            v-model="quantity"
            :min="1"
            size="small"
            style="width: 160px;"
            ></el-input-number>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <span style="width: 40px;">实收:</span>
            <el-input
            v-model="receipts"
            placeholder="请输入"
            size="small"
            style="width: 160px;"
            ></el-input>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <span style="width: 40px;">备注:</span>
            <el-input
            v-model="remark"
            placeholder="请输入备注"
            size="small"
            style="width: 160px;"
            ></el-input>
        </div>
        <el-button
            style="width: 200px;"
            type="primary"
            size="small"
            @click="handleExtract"
        >
            提取卡密
        </el-button>
        </div>

    </div>
  </template>
  
  
  <script>
  export default {
    name: "AdminLayout",
    data() {
      return {
        renewCards: [
        ],
        prices:[],
        activeType: "", // 当前选中类型
        price: "", // 输入的价格
        quantity: 1, // 输入的数量
        receipts: "", 
        remark: ""
      };
    },
    methods: {
      changeType(type) {
        this.activeType = type;
        this.sel_price = ""; // 切换时重置
        this.quantity = 1; // 切换时重置
        console.log("选中类型:", type);
        const selectedCard = this.renewCards.find(card => card.id === type);
        if (selectedCard) {
          this.price = selectedCard.price;
        } else {
          this.price = '';
        }

        this.quantity = 1; // 数量重置
        console.log("选中类型:", type, "价格:", this.price);
      },
      async handleExtract() {

        try {
          var addForm = {
            quantity:this.quantity,
            activeType:this.activeType,
            price:this.receipts,
            remark:this.remark
          }
          const res = await this.$axios.post('/carmine/create', {
            ...addForm
          })
          if(res.code == 200){
            this.$router.push({
              name: 'GenCardPage',
              query: {
                updatedCard: JSON.stringify(res.data) // card为修改后的对象
              }
            })
          }
        } catch (err) {
          console.log(err);
        }
        this.agents.push({ ...this.addForm});
        this.$message.success('添加成功');
        this.addForm = { name: '', vxid: '', type: '', amount: '', expire: '' };
      },
      async cardPrice() {
        try {
          const res = await this.$axios.post('/carmine/cardprice', {
          })
          console.log(res);
          if(res.code == 200){
            this.renewCards = res.data;
          }
          console.log(res);
        } catch (err) {
          console.log(err);
        }
      },
    },
    mounted(){
      this.cardPrice()
    }
  };
  </script>
  
  
  <style scoped>
  .admin-layout {
    display: flex;
    width: 100vw;
    height: 100vh;
    background: #fff;
  }
  
  .sidebar {
    width: 220px;
    background: #222;
    color: #fff;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .sidebar-logo {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 22px 16px 18px 16px;
  }
  
  .sidebar-logo-img {
    width: 38px;
    height: 38px;
    margin-right: 8px;
    object-fit: contain;
  }
  
  .sidebar-logo-info {
    display: flex;
    flex-direction: column;
  }
  
  .sidebar-title {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
  }
  
  .sidebar-subtitle {
    font-size: 10px;
    letter-spacing: 1px;
    margin-top: 2px;
  }
  
  .sidebar-menu {
    border: none;
    background: #222;
    margin-top: 16px;
  }

  .renew-card.selected {
    border: 2px solid #1890ff; /* 蓝色边框 */
    }

    /* 选中文本信息，文字蓝色 */
    .renew-card-info.selected .renew-card-title,
    .renew-card-info.selected .renew-card-desc {
    color: #1890ff;
    font-weight: 600;
    }
  
    .renew-card-extra {
  padding: 12px;
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0 0 20px 20px;
  box-sizing: border-box;
}

.renew-card.selected {
  border: 2px solid #1890ff;
}

.renew-card-info.selected .renew-card-title,
.renew-card-info.selected .renew-card-desc {
  color: #1890ff;
  font-weight: 600;
}
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #fff;
  }
  
  .header-bar {
    height: 60px;
    background: #888;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 36px 0 0;
  }
  
  .header-right {
    display: flex;
    align-items: center;
  }
  
  .header-username {
    margin-left: 10px;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
  }
  
  .content-area {
    padding: 38px 0 0 38px;
    width: 100%;
  }
  
  .content-title {
    font-size: 16px;
    color: #222;
    margin-bottom: 28px;
    font-weight: 500;
    text-align: left;
  }
  
  .card-list {
    display: flex;
    flex-direction: row;
    gap: 32px;
  }
  
  .renew-card {
    background: #f7f7f7;
    border-radius: 20px;
    box-shadow: 0 2px 8px #eee;
    width: 200px;
    height: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 18px 0 0 0;
    background-image: URL('~@/assets/images/小财神形象.png');
    background-size: cover;
    color:#222;
  }
  
  .renew-card-img {
    width: 110px;
    height: 150px;
    border-radius: 14px;
    object-fit: cover;
    margin-bottom: 16px;
  }
  
  .renew-card-info {
    text-align: center;
    margin-top: auto;
    width: 100%;
    background: rgba(255, 255, 255, 0.85); /* 半透明白，柔和过渡 */
    height: 70px;
    border-radius: 0 0 20px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px 0;  /* 增加上下空间 */
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1); /* 顶部阴影，制造浮起效果 */
    backdrop-filter: blur(6px); /* 可选：毛玻璃效果，层次更高级 */
    transition: all 0.3s ease; /* 可选：做 hover 动画会更丝滑 */
    }
  
  .renew-card-title {
    font-size: 14px;
    font-weight: 500;
    /* color: #222; */
    margin-bottom: 6px;
    
  }
  
  .renew-card-desc {
    font-size: 13px;
    /* color: #7a7a7a; */
  }
  </style>